<template>
  <b-modal :visible="modal" @hide="resetAndCloseModal">
    <div slot="modal-title">
      {{ $t('locateAMissingLicense') }}
    </div>
    <b-container fluid v-if="!isApiCallComplete">
      <b-row>
        <div class="col-12">
          <p class="description">{{ $t('missingLicenseHelpText') }}</p>
        </div>
      </b-row>
      <b-row>
        <div class="col-12 text-center">
          <fieldset class="form-group">
            <legend style="text-align: left;">{{ $t('enterLicenseCode') }}</legend>
            <div class="select-container">
              <b-input
                v-model="hostValue"
                class="host-style-input"
                @input="isWebkeyInvalid = false"
              />
            </div>
          </fieldset>
          <div class="danger-text text-left" v-if="isWebkeyInvalid">
            {{ $t('invalidWebkey') }}
          </div>
          <div>
            <b-button
              :disabled="isCtaButtonDisabled || isLoading"
              class="cta-btn"
              variant="primary"
              size="lg"
              @click="getWebkeyLicenses"
            >
              {{ $t('addLicense') }}
              <i v-if="isLoading" class="fa fa-spinner loading-animation" />
            </b-button>
            <div>
              <a href="#" class="danger-text" @click.stop.prevent="resetAndCloseModal">
                {{ $t('cancel') }}
              </a>
            </div>
          </div>
        </div>
      </b-row>
    </b-container>
    <b-container v-else class="text-center">
      <b-row v-if="screen === 1">
        <div class="col-12">
          <p class="description">{{ $t('webkeyAllocate') }}</p>
        </div>
        <div class="col-12">
          <b-button
            class="cta-btn"
            variant="primary"
            size="lg"
            @click="proceedToAllocate"
            >
              {{ $t('allocateNow') }}
          </b-button>
        </div>
        <div class="col-12">
          <a href="#" class="danger-text" @click.stop.prevent="resetAndCloseModal">
            {{ $t('cancel') }}
          </a>
        </div>
      </b-row>
      <b-row v-if="screen === 2">
        <div class="col-12">
          <p
            class="description"
            v-html="$t('webkeyRegistered', { customerServiceUrl: UrlBuilder.customerServiceUrl })"
          />
          <div class="col-12">
            <a
              class="btn btn-primary btn-lg border-radius"
              :href="UrlBuilder.customerServiceUrl"
              target='_blank'
            >
              {{ $t('contactCustomerService') }}
            </a>
          </div>
          <div class="col-12">
            <a href="#" class="danger-text" @click.stop.prevent="resetAndCloseModal">
              {{ $t('closeWindow') }}
            </a>
          </div>
        </div>
      </b-row>
      <b-row v-if="screen === 3">
        <div class="col-12">
          <p
            class="description"
            v-html="$t('webkeyInvalid', { customerServiceUrl: UrlBuilder.customerServiceUrl})"
          />
        </div>
        <div class="col-12">
          <b-button
            class="cta-btn"
            variant="primary"
            size="lg"
            @click="resetModal"
            >
              {{ $t('reenterCode') }}
          </b-button>
        </div>
        <div class="col-12">
          <a href="#" class="danger-text" @click.stop.prevent="resetAndCloseModal">
            {{ $t('cancel') }}
          </a>
        </div>
      </b-row>
    </b-container>
    <div slot="modal-footer" />
  </b-modal>
</template>
<script>
import { mapMutations } from 'vuex'
export default {
  name: 'WebKeyAllocation',
  data () {
    return {
      hostValue: '',
      isWebkeyInvalid: false,
      isApiCallComplete: false,
      shouldProceedToAllocate: false,
      licenses: [],
      isLoading: false,
      screen: 0,
      hostValueUpdated: false
    }
  },
  props: {
    modal: { type: Boolean, required: true },
    closeModal: { type: Function, required: true },
    webkeyModalCallback: { type: Function, required: true },
    allocateFlowCallback: { type: Function, required: true },
    webkey: { type: String, default: '' }
  },
  updated () {
    if (!this.hostValueUpdated) {
      this.hostValue = this.webkey
      this.hostValueUpdated = true
    }
  },
  computed: {
    isCtaButtonDisabled () {
      return this.hostValue === '' || this.isHostValueInvalid
    },
    isHostValueInvalid () {
      return !/^([0-9a-zA-Z]*-){2,}([0-9a-zA-Z]*)$/ig.test(this.hostValue)
    }
  },
  methods: {
    ...mapMutations(['IS_ALLOW_PARTIAL_FOR_WEB_KEY']),
    getWebkeyLicenses () {
      this.isLoading = true
      this.bottle
        .get(this.UrlBuilder.getWebkeyUrl(this.hostValue, this.$store.getters.person.customerId))
        .then(({ data }) => {
          const { Licenses = [], WebKeyStatus, TotalCount, MinDate, MaxDate, IsPartialForWebKey } = data
          this.isLoading = false
          this.isApiCallComplete = true
          this.IS_ALLOW_PARTIAL_FOR_WEB_KEY(IsPartialForWebKey)
          if (WebKeyStatus === 'NewWebKey') {
            this.screen = 1
            this.licenses = Licenses
          } else if (WebKeyStatus === 'WebKeyRegistered') {
            this.screen = 2
          } else if (WebKeyStatus === 'InvalidKey') {
            this.screen = 3
          } else if (WebKeyStatus === null) {
            this.webkeyModalCallback(null, Licenses, TotalCount, MinDate, MaxDate)
          }
        })
        .catch((error) => {
          this.isLoading = false
          this.loggly.log({
            errorMessage: 'Failed to fetch webkey licenses',
            errorObject: error,
            errorStack: error.stack
          })
        })
    },
    resetModal () {
      this.hostValue = ''
      this.isWebkeyInvalid = false
      this.isApiCallComplete = false
      this.shouldProceedToAllocate = false
      this.licenses = []
      this.isLoading = false
      this.screen = 0
    },
    resetAndCloseModal () {
      this.resetModal()
      this.closeModal()
    },
    proceedToAllocate () {
      this.allocateFlowCallback(this.licenses)
    }
  }
}
</script>
<style lang="scss" scoped>
  @import '../styles/variables.scss';

  a:not(.btn),
  a:not(.btn):hover {
    color: $primary;
    text-decoration: none;
  }
  .cta-btn {
    border-radius: 25px;
    margin-top: 20px;
    margin-bottom: 20px;
    margin-left: auto;
    margin-right: auto;
    padding-left: 30px;
    padding-right: 30px;
  }
  fieldset {
    border: 1px solid $lightGray;
    border-radius: 5px;
    padding: 10px 0 0;
    width: 100%;
  }
  fieldset > legend {
    padding: 0 10px;
    margin-left: 10px;
    width: auto;
    font-size: 14px;
    color: $darkGray;
    margin-bottom: 0;
    z-index: $legendZIndex;
    position: relative;
    background-color: white;
  }
  .select-container {
    margin: -20px 0 0;
    min-height: 40px;
  }
  .host-style-input {
    padding-top: 10px;
    padding-bottom: 10px;
    border-bottom-color: transparent;
  }
  .description {
    font-size: 18px;
  }
  .danger-text {
    color: $danger;
  }
  .border-radius {
    border-radius: 25px;
  }
  .loading-animation {
    animation: loading-spin infinite 1s linear;
  }
  @keyframes loading-spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }
</style>




// WEBPACK FOOTER //
// src/components/WebKeyAllocationModal.vue